<template>
    <div class="activity-item" @click="handleClick">
        <!-- Image -->
        <img class="image" :src="item.image" v-if="item.image" />

        <!-- Name -->
        <span class="name">
            {{ item.name }}
        </span>

        <!-- Meta -->
        <div class="meta">
            <!-- Duration -->
            <span class="duration">
                {{ item.duration }}
                Minuten
            </span>

            <!-- Price -->
            <span class="price">
                {{ item.price | formatPrice }}
                &euro;
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {
            handleClick() {
                this.$emit('click', this.item)
            },
        },
        watch: {}
    }
</script>
